import axios from "axios";



export const getEstimatePDF = async (token, id) => {
    try {
        const response = await axios.post(
          `${process.env.REACT_APP_BASE_API_URL}/download-estimate`,
          { estimate_id: +id },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            responseType: 'blob', // This ensures you receive the response as a file
          }
        );
        return response.data;
      } catch (error) {
        console.error("Error fetching PDF:", error);
        throw error;
      }
};